var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{on:{"click":_vm.showSummary}},[_c('Header'),_c('router-view'),_c('Error'),(_vm.isDev)?_c('Ribbon'):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }